<template>
  <main>
    <ec-page-heading
      :paragraph="paragraph"
      :show-image="false"
      :sub-title="subTitle"
      :title="pageTitle"
      class="intro-text wrapper pt-5 pb-5"
    />
  </main>
</template>

<script>
import ecPageHeading from '@/components/General/PageHeading'
import Location from '@/mixins/Location'

export default {
  name: 'ec-page-not-found',
  components: {
    ecPageHeading
  },
  mixins: [Location],
  data () {
    return {}
  },
  computed: {
    pageTitle () {
      return 'Error 404!'
    },
    paragraph () {
      return 'Onze mascotte heeft de opgevraagde pagina niet kunnen vinden.'
    },
    subTitle () {
      return 'Pagina niet gevonden..'
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === null) {
      next(vm => {
        vm.getSiteData()
      })
    } else {
      next(vm => {
        vm.$store.commit('setIsLoading', false)
      })
    }
  }
}
</script>
